import useCurrentUser from 'auth/useCurrentUser'

export const useHasAnyPurchasedGuide = () => {
  const [{ currentUser }] = useCurrentUser()

  return currentUser?.subscriberStatus === 'Guides Purchaser'
}

export const useHasPurchasedGuide = guideId => {
  const [{ currentUser }] = useCurrentUser()
  return currentUser?.purchasedGuideIds?.includes?.(guideId)
}
